/* eslint-disable @typescript-eslint/no-explicit-any */
import { signalStore } from '@ngrx/signals';
import { AbstractQueryParams, OffSubscriptionWithCatch, withActions, withSelectors } from '@res/ngg-core';
import { AddressData, AddressDef, AddressRef, UserDoc, UserId } from '../../schema/schema.interface';
import { AddressActions } from './address.action';
import { AddressState } from './address.state';

export type AddressStoreModel = AddressData & { ref: AddressRef };
export interface AddressStateModel {
  addresses: AddressStoreModel[];
  selectedUser?: UserDoc;
  isSubscribed: boolean;
  off?: OffSubscriptionWithCatch;
  isLoading: boolean;
  filter?: { parent: UserId; query: AbstractQueryParams<AddressDef>[] };
}

export const AddressStore = signalStore(
  // Selectors
  { protectedState: false },
  withSelectors({
    addresses: AddressState.addresses,
    addressesByUser: AddressState.addressesByUser,
    addressState: AddressState.addressState,
  }),
  // Actions
  withActions({
    addAddress: AddressActions.CreateAddress,
    initAddress: AddressActions.InitAddress,
    updateAddress: AddressActions.UpdateAddress,
    getAllAddress: AddressActions.GetAllAddress,
    queryAddress: AddressActions.QueryAddress,
    setSelectedUser: AddressActions.SetSelectedUser,
  }),
);
